<template>
  <div class="home">
    <My-new-nav ref="header" menuTheme="dark"></My-new-nav>
    <div class="home-part4">
      <div class="mobile-margin">
        <div class="home_text3 home_title">部分合作伙伴</div>
        <div class="home_text_desc-top home_desc">携手合作伙伴，共建医疗新生态，共赢未来</div>
        <div class="rectangle"></div>
        <ul>
          <li class="drug" v-for="(item, i) in enterpriseList" :key="i">
            <img :src="item.imgUrl" alt="" />
          </li>
        </ul>
      </div>
      <img class="drug_bottom" src="../../assets/image/home/drug_bottom.png" alt="">
    </div>
  </div>
</template>

<script>

import Information from "@/views/mobile/Information.vue";
import { selectEnterpriseList } from "../../../common/api";
export default {
  components: {Information},
  data() {
    return {
      enterpriseList: [],
    };
  },
  mounted() {
    this.getCoopEnterpriseList();
  },
  methods: {
    getCoopEnterpriseList() {
      let data = {
        isOfficial: 1,
        pageIndex: 1,
        pageSize: 10000,
      };
      selectEnterpriseList(data).then((res) => {
        if (res.responseCode == 0 && Array.isArray(res.responseBody)) {
          this.enterpriseList = res.responseBody
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.home {
  width: 100%;
  padding-top: 120px;
  background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.8)), url("../../assets/image/home/moble_home_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.rectangle {
  width: 86px;
  height: 18px;
  background: #0D6EFD;
  opacity: 0.9;
  margin-top: 20px;
}
.mobile-margin {
  margin: 0 36px;
}

.home_title {
  font-size: 54px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 54px;
  letter-spacing: 5px;
}

.home_desc {
  font-size: 30px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 24px;
  letter-spacing: 5px;
  margin-top: 12px;
}

.home_text3 {
  padding-top: 80px;
}

.home_text_desc-top {
  padding-top: 18px;
}
.home-part4 {
  
}

.home-part4 ul {
  margin-top: 69px;
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
}
.home-part4 ul li {
  background: #fff;
  width: calc((100% - 36px) / 3);
  height: 158px;
  border-radius: 12px;
}
.home-part4 ul li>img {
  width: 100%;
  height: 100%;
}
.home-part4 .drug {
  margin: 18px 18px 0 0;
}
.home-part4 .drug:nth-child(3n) {
  margin-right: 0;
}
.drug_bottom{
  width: 100%;
  height: 198px;
  margin-top: -70px;
}
</style>
